import { Button, Image, VerifiedBadge } from "@garther/ui/components";
import { useI18n } from "@garther/ui/libs";
import { createFileRoute, useNavigate, useRouteContext } from "@tanstack/react-router";
import { PenLine, Star } from "lucide-react";

import { OrgAbout } from "./-components/org-about";

export const Route = createFileRoute("/_auth/org/$orgId/")({
  component: RouteComponent
});

function RouteComponent() {
  const { formatDate, t } = useI18n();
  const navigate = useNavigate();
  const { org } = useRouteContext({ from: "/_auth/org/$orgId/" });

  if (!org) return <div>{t("org.notFound")}</div>;

  const onEditBtnClick = () => {
    navigate({ to: "/org/$orgId/edit", params: { orgId: org.id } });
  };

  return (
    <div className="min-h-full">
      <div className="relative h-[200px] sm:h-[260px] lg:h-[280px]">
        <Image src={org.cover} alt={org.name} className="w-full h-full object-cover rounded-2xl" />
        <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-background-primary/80 via-background-primary/55 via-25% to-60% to-transparent" />
      </div>

      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 pb-16">
        <div className="relative -mt-12 sm:-mt-20 mb-8 flex flex-col sm:flex-row items-start gap-6">
          <div className="rounded-xl overflow-hidden bg-card border-[3px] border-border-light shadow-lg w-24 h-24 sm:w-36 sm:h-36">
            <Image src={org.avatar} alt={org.name} className="w-full h-full object-cover" />
          </div>
          <div className="flex-1 space-y-3 flex flex-col sm:flex-row justify-between">
            <div className="space-y-3">
              <div className="space-y-1">
                <p className="items-center">
                  <span className="font-normal text-text-primary text-responsive-5xl">{org.name}</span>
                  {org.verified && <VerifiedBadge className="inline-block ml-2" size="sm" />}
                </p>
                <p className="text-responsive-base text-text-primary font-normal">{org.tagline}</p>
              </div>
              <div className="flex items-center gap-1">
                <Star className="h-5 w-5 fill-amber-400 text-amber-400" />
                <span className="font-medium">{org.stats.rating}</span>
                <span className="text-muted-foreground">
                  ({org.stats.totalReviews} {t("org.reviews.count")})
                </span>
              </div>
              <p className="text-responsive-sm text-text-secondary font-medium">
                {t("org.created")}{" "}
                {formatDate(org.createdAt, {
                  month: "short",
                  day: "numeric",
                  year: "numeric"
                })}
              </p>
            </div>
            <div className="flex items-end gap-2">
              <Button onClick={onEditBtnClick} variant="outline">
                <PenLine className="h-4 w-4 mr-2" />
                {t("common.edit")}
              </Button>
            </div>
          </div>
        </div>

        <OrgAbout org={org} />
      </div>
    </div>
  );
}
